module.exports = __webpack_public_path__ + "static/logo-6e40f8ba968d3b64c459f68d8a8b1494.svg";